var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H5M21 21H19M5 21H19M5 21V9.32837M19 21V9.32837M5 9.32837C4.96299 9.307 4.92651 9.28434 4.8906 9.2604L4.35024 8.90016C3.56331 8.37554 3.25144 7.37141 3.60269 6.49328L4.49711 4.25722C4.80084 3.4979 5.53626 3 6.35407 3H17.6459C18.4637 3 19.1992 3.4979 19.5029 4.25722L20.3973 6.49328C20.7486 7.37141 20.4367 8.37554 19.6498 8.90016L19.1094 9.2604C19.0735 9.28434 19.037 9.307 19 9.32837M5 9.32837C5.65537 9.70699 6.47351 9.68433 7.1094 9.2604L9 8L10.8906 9.2604C11.5624 9.70827 12.4376 9.70827 13.1094 9.2604L15 8L16.8906 9.2604C17.5265 9.68433 18.3446 9.70699 19 9.32837",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21V16C14 14.8954 13.1046 14 12 14V14C10.8954 14 10 14.8954 10 16V21",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubsIcon);
export default __webpack_public_path__ + "static/media/clubs_icon.4a22f2ee7895b5b7fed3d8da4764403a.svg";
export { ForwardRef as ReactComponent };